import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../../components/access-management/access-management.component';
import { Annotation } from '../models/Annotation';

@Injectable({
  providedIn: 'root'
})
export class HttpcallService {
  private _baseUrl: string;
  constructor(
    private http: HttpClient
  ) {
    this._baseUrl = "";
  }

  getAnnotation(paragraphId: string, orderAscending: string) {
    return this.http.get(this._baseUrl + "/paragraphAction/getAnnotation?paragraphId=" + paragraphId + "&orderAscending=" + orderAscending);
  }

  getElasticAnnotation(searchTerm: string, top: string, area: string) {
    return this.http.get(this._baseUrl + "/paragraphAction/GetElasticSearchAnnotation?searchTerm=" + searchTerm + "&top="+top+"&area="+area);
  }

  getAnnotationCount(paragraphActionInputBody)
  {
    return this.http.post(this._baseUrl + "/paragraphAction/GetAnnotationCount", paragraphActionInputBody);
  }

  addUpdateAnnotation(annotation: Annotation) {
    return this.http.post(this._baseUrl + "/paragraphAction/addAnnotation", annotation, { responseType: 'text' });
  }

  getBookmark(paragraphId: string) {
    return this.http.get(this._baseUrl + "/paragraphAction/GetBookMark?paragraphId=" + paragraphId);
  }

  getMyBookmark(paragraphId: string) {
    return this.http.get("/paragraphAction/GetBookMark?paragraphId=" + paragraphId + "&myBookmark=" + true);
  }

  getElasticBookmark(searchTerm: string, top: string, area: string) {
    return this.http.get(this._baseUrl + "/paragraphAction/GetElasticSearchBookMark?searchTerm=" + searchTerm + "&top=" + top+"&area="+area);
  }

  getTopBookmark() {
    return this.http.get(this._baseUrl + "/paragraphAction/GetTop5Bookmark")
  }

  getBookmarkCount(paragraphActionInputBody) {
    return this.http.post(this._baseUrl + "/paragraphAction/GetBookmarkCount", paragraphActionInputBody)
  }

  addUpdateBookmark(bookmark) {
    return this.http.post(this._baseUrl + "/paragraphAction/addBookMark", bookmark, { responseType: 'text' });
  }

  getMyHistory() {
    return this.http.get(this._baseUrl + "/paragraphAction/GetMyHistory");
  }

  getTopAnnotation() {
    return this.http.get(this._baseUrl + "/paragraphAction/GetTopAnnotation");
  }

  addHistory(history) {
    return this.http.post(this._baseUrl + "/paragraphAction/addHistory", history, { responseType: 'text' });
  }

  addAllHistory(history) {
    return this.http.post(this._baseUrl + "/paragraphAction/addAllHistory", history, { responseType: 'text' });
  }

  getMyHistoryForTable(timeDuration: string) {
    return this.http.get(this._baseUrl + "/paragraphAction/GetMyHistoryForTable?timeDuration=" + timeDuration);
  }

  addSearchTerm(searchTerm) {
    return this.http.post(this._baseUrl + "/paragraphAction/addSearchTerm", searchTerm, { responseType: 'text' });
  }

  getRecentSearchTerm() {
    return this.http.get(this._baseUrl + "/paragraphAction/GetRecentSearchTerm");
  }

  getPageAnnotation(inputBody) {
    return this.http.post<any>(this._baseUrl + "/paragraphAction/GetPageAnnotations", inputBody);
  }
  getAllUsers() {
    return this.http.get(this._baseUrl + "/paragraphAction/getAllUser");
  }
  addUpdateUser(user: User) {
    return this.http.post(this._baseUrl + "/paragraphAction/addUser", user, { responseType: 'text' });
  }
}
